import React from "react";
import { MapPin, Mail, Phone, ArrowRight, Building2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="14720" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-5 w-24 bg-white/5 animate-pulse rounded-sm" data-index={i} />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <nav className="flex flex-col gap-3">
        <Link to="/HomePage" className="text-slate-400 hover:text-[#D4AF37] transition-colors text-sm font-medium tracking-tight">Home</Link>
        <Link to="/OurStoryPage" className="text-slate-400 hover:text-[#D4AF37] transition-colors text-sm font-medium tracking-tight">Our Story</Link>
        <Link to="/AIChecklistPage" className="text-slate-400 hover:text-[#D4AF37] transition-colors text-sm font-medium tracking-tight">AI Checklist</Link>
        <Link to="/LetsTalkPage" className="text-slate-400 hover:text-[#D4AF37] transition-colors text-sm font-medium tracking-tight">Let's Talk</Link>
      </nav>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-slate-400 hover:text-[#D4AF37] transition-colors text-sm flex items-center gap-2 group font-medium tracking-tight" data-index={i}>
          <span className="w-0 group-hover:w-2 h-[1px] bg-[#D4AF37] transition-all duration-300" />
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const businessName = "Cyril Consulting Group";
  const address = "New York • Florida • Guyana";
  const regions = ["AI Strategy", "Cloud Transformation", "Digital Advisory"];
  return <section id="footer" className="dark bg-[#1A2A4E] text-white py-16 lg:py-24 border-t border-white/5">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://cyrilconsultinggroup.com/wp-content/uploads/2026/04/Cyril-Consulting-Group-logo-design-1.png" alt={businessName} className="h-8 w-auto object-contain transition-opacity !opacity-[0.9] hover:opacity-90" />
            </Link>
            <div className="flex flex-col gap-4 text-slate-400 text-sm leading-relaxed font-sans">
              <p className="max-w-[240px]">
                Empowering global enterprises to master AI, cloud architecture, and automation for sustainable digital growth.
              </p>
              <div className="flex items-start gap-3 mt-2">
                <MapPin className="w-4 h-4 mt-1 shrink-0 text-[#008080]" />
                <span className="text-slate-300">{address}</span>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-xs font-bold tracking-widest uppercase text-white/50">Navigation</h3>
            <MenuProvider menu_id="54" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-xs font-bold tracking-widest uppercase text-white/50">Core Expertise</h3>
            <ul className="flex flex-col gap-3">
              {regions.map((region, i) => <li key={region} className="flex items-center gap-3 text-slate-400 text-sm font-medium" data-index={i}>
                  <div className="w-1.5 h-1.5 rounded-full bg-[#008080]" />
                  {region}
                </li>)}
            </ul>
            <div className="mt-2 p-4 bg-white/5 rounded-lg border border-white/10 backdrop-blur-md">
              <div className="flex items-center gap-3 mb-2">
                <Building2 className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-[10px] font-bold text-white/70 uppercase tracking-widest">Client Success</span>
              </div>
              <p className="text-xl font-bold text-white tracking-tight">98% Retention</p>
              <p className="text-[10px] text-slate-500 uppercase tracking-wider mt-1">Enterprise Partners</p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-xs font-bold tracking-widest uppercase text-white/50">Consultation</h3>
            <div className="flex flex-col gap-4">
              <p className="text-sm text-slate-400 leading-relaxed"><span data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:h0ifpv" data-ast-start="4936" data-ast-end="5100" style={{
                letterSpacing: '-0.32px'
              }} contenteditable="false">Schedule a Meeting – Book your private consultation with senior technology advisors.</span><div data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:3r02fm" data-ast-start="5100" data-ast-end="5117"><br /></div><div data-ast-id="f:/src/reusable_sections/Footer.tsx|sig:3qza97" data-ast-start="5117" data-ast-end="5212">AI Readiness Checklist – Evaluate your business for AI adoption and cloud readiness.</div></p>
              
              <div className="flex flex-col gap-3 mt-2">
                <Button asChild variant="outline" className="justify-start border-white/20 bg-transparent text-white hover:bg-[#008080] hover:text-white hover:border-[#008080] transition-all group rounded-sm">
                  <Link to="/LetsTalkPage">
                    <Mail className="w-4 h-4 mr-2 group-hover:scale-110 transition-transform" />
                    Schedule Meeting
                  </Link>
                </Button>
                
                <Button asChild variant="ghost" className="justify-start hover:bg-transparent hover:text-[#D4AF37] p-0 h-auto font-medium text-slate-400">
                  <Link to="/AIChecklistPage" className="flex items-center gap-2 group">
                    <span>AI Readiness Checklist</span>
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

        </div>

        <Separator className="bg-white/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-widest text-white/30 font-bold">
          <p>&copy; {currentYear} {businessName}. Built for the Digital Era.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-white transition-colors">Legal Terms</Link>
          </div>
        </div>
      </div>
    </section>;
}